import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MetricConfiguration from './metric-configuration-model'
import {
  CreateMetricConfigurationAsync,
  DeleteMetricConfigurationAsync,
  LoadMetricConfigurationsAsync,
} from './metricConfiguration-thunk'
const initialState: metricConfigurationSliceState = {
  metricConfiguration: [],
  selected_metricConfiguration: '',
  is_loading_metricConfiguration: false,
  is_creating_metricConfiguration: false,
  is_deleting_metricConfiguration: false,
}
export interface metricConfigurationSliceState {
  metricConfiguration: MetricConfiguration[]
  selected_metricConfiguration?: string
  is_loading_metricConfiguration: boolean
  is_creating_metricConfiguration: boolean
  is_deleting_metricConfiguration: boolean
}
export const metricConfigurationSlice = createSlice({
  name: 'metricConfiguration',
  initialState,
  reducers: {
    setSelectedmetricConfiguration: (state, action) => {
      state.selected_metricConfiguration = action.payload
    },
    clearStatemetricConfiguration: (state) => {
      state.metricConfiguration = []
      state.is_loading_metricConfiguration = false
      state.is_creating_metricConfiguration = false
      state.is_deleting_metricConfiguration = false
    },
    mergemetricConfiguration: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricConfiguration = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricConfiguration = merge(
            state.metricConfiguration,
            payload,
          ) as any
        }
      }
    },

    add_metricConfiguration: (state, action) => {
      if (action.payload) {
        state.metricConfiguration = [
          ...state.metricConfiguration,
          action.payload,
        ]
      }
    },
    set_metricConfiguration: (state, action) => {
      let { key, value, id } = action.payload
      state.metricConfiguration = state.metricConfiguration.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricConfigurationsAsync.pending, (state) => {
      state.is_loading_metricConfiguration = true
    })
    builder.addCase(
      LoadMetricConfigurationsAsync.fulfilled,
      (state, action) => {
        state.is_loading_metricConfiguration = false
        if (action.payload) {
          state.metricConfiguration = action.payload
        }
      },
    )
    builder.addCase(LoadMetricConfigurationsAsync.rejected, (state) => {
      state.is_loading_metricConfiguration = false
    })
    builder.addCase(CreateMetricConfigurationAsync.pending, (state) => {
      state.is_creating_metricConfiguration = true
    })
    builder.addCase(CreateMetricConfigurationAsync.fulfilled, (state) => {
      state.is_creating_metricConfiguration = false
    })
    builder.addCase(CreateMetricConfigurationAsync.rejected, (state) => {
      state.is_creating_metricConfiguration = false
    })
    builder.addCase(DeleteMetricConfigurationAsync.pending, (state) => {
      state.is_deleting_metricConfiguration = true
    })
    builder.addCase(
      DeleteMetricConfigurationAsync.fulfilled,
      (state, action) => {
        state.is_deleting_metricConfiguration = false
        if (state.metricConfiguration) {
          state.metricConfiguration = state.metricConfiguration.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteMetricConfigurationAsync.rejected, (state) => {
      state.is_deleting_metricConfiguration = false
    })

    builder.addCase(autoThunks.get_metric_configurations.pending, (state) => {
      state.is_loading_metricConfiguration = true
    })
    builder.addCase(
      autoThunks.get_metric_configurations.fulfilled,
      (state, action) => {
        state.is_loading_metricConfiguration = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_metric_configurations.rejected, (state) => {
      state.is_loading_metricConfiguration = false
    })

    builder.addCase(autoThunks.store_metric_configurations.pending, (state) => {
      state.is_loading_metricConfiguration = true
    })
    builder.addCase(
      autoThunks.store_metric_configurations.fulfilled,
      (state, action) => {
        state.is_loading_metricConfiguration = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.store_metric_configurations.rejected,
      (state) => {
        state.is_loading_metricConfiguration = false
      },
    )

    builder.addCase(
      autoThunks.delete_metric_configurations.pending,
      (state) => {
        state.is_loading_metricConfiguration = true
      },
    )
    builder.addCase(
      autoThunks.delete_metric_configurations.fulfilled,
      (state, action) => {
        state.is_loading_metricConfiguration = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.delete_metric_configurations.rejected,
      (state) => {
        state.is_loading_metricConfiguration = false
      },
    )
  },
})

function handleResult(action: any, state: metricConfigurationSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_metricConfiguration = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.metricConfiguration = merge(
        state.metricConfiguration,
        payload,
      ) as any
    }
  }
}

export const {
  clearStatemetricConfiguration,
  setSelectedmetricConfiguration,
  set_metricConfiguration,
  mergemetricConfiguration,
  add_metricConfiguration,
} = metricConfigurationSlice.actions

export const get_metricConfiguration =
  (id?: string) =>
  (state: {
    metricConfiguration: {
      metricConfiguration: MetricConfiguration[]
    }
  }): MetricConfiguration | null => {
    let temp = state?.metricConfiguration?.metricConfiguration?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.metricConfiguration?.metricConfiguration[0] || null
  }
export const get_selected_metricConfiguration = (state: {
  metricConfiguration: metricConfigurationSliceState
}): MetricConfiguration | null => {
  let id = state?.metricConfiguration?.selected_metricConfiguration
  let temp = state?.metricConfiguration?.metricConfiguration?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricConfiguration = (state: {
  metricConfiguration: {
    metricConfiguration: MetricConfiguration[]
  }
}): MetricConfiguration[] => {
  let temp = state?.metricConfiguration?.metricConfiguration
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricConfiguration_busy = (state: {
  metricConfiguration: metricConfigurationSliceState
}) => {
  return (
    state?.metricConfiguration.is_deleting_metricConfiguration ||
    state?.metricConfiguration.is_loading_metricConfiguration ||
    state?.metricConfiguration.is_creating_metricConfiguration
  )
}
export const is_deleting_metricConfiguration_busy = (state: {
  metricConfiguration: metricConfigurationSliceState
}) => {
  return state?.metricConfiguration.is_deleting_metricConfiguration
}
export const is_loading_metricConfiguration_busy = (state: {
  metricConfiguration: metricConfigurationSliceState
}) => {
  return state?.metricConfiguration.is_loading_metricConfiguration
}
export const is_creating_metricConfiguration_busy = (state: {
  metricConfiguration: metricConfigurationSliceState
}) => {
  return state?.metricConfiguration.is_creating_metricConfiguration
}

export default metricConfigurationSlice.reducer
